import { memo } from 'react';

import { DeleteFilled } from '@ant-design/icons';
import { Button } from 'antd';

function RemoveConditionComponent({ handleOnClick }) {
  return (
    <Button
      color="default"
      variant="outlined"
      icon={<DeleteFilled className="text-primary" />}
      title="Delete condition"
      onClick={handleOnClick}
    />
  );
}

export default memo(RemoveConditionComponent);
